
import React from 'react';
import { useNavigate } from 'react-router-dom';
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from '@/components/ui/card';
import { Button } from '@/components/ui/button';
import { AlertCircle } from 'lucide-react';

interface InviteErrorCardProps {
  error: string;
  token?: string;
}

export const InviteErrorCard = ({ error, token }: InviteErrorCardProps) => {
  const navigate = useNavigate();

  return (
    <div className="min-h-screen flex items-center justify-center bg-gray-50 p-4">
      <Card className="w-full max-w-md">
        <CardHeader className="text-center">
          <AlertCircle className="h-12 w-12 text-red-500 mx-auto mb-4" />
          <CardTitle className="text-red-600">Invalid Invitation</CardTitle>
          <CardDescription className="text-sm">{error}</CardDescription>
        </CardHeader>
        <CardContent>
          <Button 
            onClick={() => navigate('/auth')} 
            className="w-full"
          >
            Go to Sign In
          </Button>
        </CardContent>
      </Card>
    </div>
  );
};
